import React from 'react'
import Route from 'route-parser'
import { useSelector } from 'react-redux'
import Grid from '@material-ui/core/Grid'
import Hidden from '@material-ui/core/Hidden'
import CloudDownload from '@material-ui/icons/CloudDownload'
import { URL_DATA } from 'constants/urls'
import selectAolName from 'redux/selectors/selectAolName'
import TealToolTip from 'components/TealToolTip'

const SectionHeading = ({ precedentId }) => (
  <Grid item xs={12}>
    <header className='section-heading relative pt8 mb7'>
      <div className='b f3 m6 ml3'>
        {precedentId === 'new' ? 'Upload' : 'Edit'} Precedent
      </div>
      <Hidden xsDown>
        <DownLoadIconButton {...{ precedentId }} />
      </Hidden>
    </header>
  </Grid>
)

const DownLoadIconButton = ({ precedentId }) => {
  const aol = useSelector(selectAolName)
  const dataRoute = new Route(URL_DATA).reverse({ aol, id: precedentId })

  return (precedentId === 'new')
    ? null
    : (
      <div className='absolute bottom0 right3 pointer'>
        <TealToolTip title='Download' placement='left'>
          <a href={dataRoute || null}>
            <CloudDownload />
          </a>
        </TealToolTip>
      </div>
      )
}

export default SectionHeading
